import { ReactNode } from "react";
import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

type StreamingErrorPopupProps = {
  message: string;
  btnText: string;
  btnAction: VoidFunction;
  header?: string;
  headerIcon?: ReactNode;
};

export default function CenterPopup({
  header,
  message,
  btnText,
  btnAction,
  headerIcon,
}: StreamingErrorPopupProps) {
  return (
    <Container>
      {/* {headerIcon} */}
      {!!header && (
        <Typography variant="h3" gutterBottom>
          {header}
        </Typography>
      )}

      <Typography variant="h6">{message}</Typography>

      <CallToAction>
        <Button variant="contained" onClick={btnAction}>
          {btnText}
        </Button>
      </CallToAction>
    </Container>
  );
}

const Container = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "calc(50% - 300px)",
  transform: "translateY(-50%)",
  gridColumnStart: 1,
  gridColumnEnd: 2,
  gridRowStart: 1,
  gridRowEnd: 2,
  placeSelf: "center",
  padding: theme.spacing(4),
  display: "flex",
  alignItems: "center",
  width: "90%",
  maxWidth: "600px",
  flexDirection: "column",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  color: theme.palette.text.primary,
  borderRadius: theme.shape.borderRadius,
  backdropFilter: "blur(5px)",
  zIndex: 5,
  [theme.breakpoints.down("md")]: {
    top: "40%",
    left: "5%",
  },
}));

const CallToAction = styled("div")({
  marginTop: "2em",
  display: "flex",
});
